// Replit App IDs
export const GPP_APP_ID = 7;

// Special receiver app names that require backward compatibility
// These apps send their app_id as the level when requesting tokens
export const SPECIAL_RECEIVER_APP_NAMES = ['Activity & Actions', 'GMV & Sales'];
